import React, { useState, useEffect } from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useParams, useNavigate } from "react-router-dom";
import { CheckCircle2 , Camera, Play, MapPin, ChevronLeft, ChevronRight} from 'lucide-react';
import Sidebar from '../Components/Sidebar'

import "swiper/css";

export default function YachtDetails() {
const [yachtMediaTab, setYachtMediaTab] = useState('photos');
  const [yachtGalleryIndex, setYachtGalleryIndex] = useState(0);

  const yachtPhotoLibrary = [
    "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1200",
    "https://images.unsplash.com/photo-1540962351504-03099e0a754b?auto=format&fit=crop&q=80&w=1200",
    "https://images.unsplash.com/photo-1621275471769-e6aa344546d5?auto=format&fit=crop&q=80&w=1200",
    "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?auto=format&fit=crop&q=80&w=1200"
  ];

  const handleNextYachtSlide = () => setYachtGalleryIndex((prev) => (prev === yachtPhotoLibrary.length - 1 ? 0 : prev + 1));
  const handlePrevYachtSlide = () => setYachtGalleryIndex((prev) => (prev === 0 ? yachtPhotoLibrary.length - 1 : prev - 1));

 

  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("description");
  const [boatdetails, setBoatdetails] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
 const [selectedSlots, setSelectedSlots] = useState([]);

  const [selectedDate, setSelectedDate] = useState("");

  // ✅ SINGLE API CALL
  useEffect(() => {
    fetch(`${API_URL}Boat/GetBoatMasterbyId?BoatId=${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setBoatdetails(data.data);
          setTimeSlots(data.data.timeslots || []);
        }
      })
      .catch((err) => console.error(err));
  }, [id]);

  if (!boatdetails) {
    return <div style={{ padding: 50 }}>Loading...</div>;
  }
const handleSlotClick = (slot) => {
  const exists = selectedSlots.find(s => s.time === slot.time);

  if (exists) {
    // remove
    setSelectedSlots(prev => prev.filter(s => s.time !== slot.time));
  } else {
    // add
    setSelectedSlots(prev => [...prev, slot]);
  }
};

  const imageUrl = boatdetails?.multipalimage
    ? `http://uat.indiaboats.in/images/Boat/${boatdetails.multipalimage}`
    : "http://uat.indiaboats.in/images/Boat/assets/img/boat1.jpg";

    const handleAddToCart = () => {
  if (selectedSlots.length === 0 ) {
    alert("Please select time");
    return;
  }
if (!selectedDate) {
    alert("Please select date");
    return;
  }
  let existingCart = JSON.parse(localStorage.getItem("cart")) || [];

  if (!Array.isArray(existingCart)) {
    existingCart = [];
  }

  let addedCount = 0;
  let duplicateCount = 0;

  selectedSlots.forEach((slot) => {
    const finalPrice =
      slot.discount > 0
        ? slot.price - (slot.price * slot.discount) / 100
        : slot.price;

    const cartItem = {
      id: boatdetails?.boatid,
      boatName: boatdetails?.boatname,
      image: imageUrl,
      date: selectedDate,
      time: slot.time,
      location: boatdetails?.placename,
      price: finalPrice,
    };

    const alreadyExists = existingCart.some(
      (item) =>
        item.id === cartItem.id &&
        item.date === cartItem.date &&
        item.time === cartItem.time
    );

    if (alreadyExists) {
      duplicateCount++;
    } else {
      existingCart.push(cartItem);
      addedCount++;
    }
  });

  localStorage.setItem("cart", JSON.stringify(existingCart));

  // ✅ User feedback
  if (addedCount > 0) {
    alert(`${addedCount} slot(s) added to cart`);
  }

  if (duplicateCount > 0) {
    alert(`${duplicateCount} slot(s) already existed`);
  }

  navigate("/cart");
};

  

  return (
    <>
      <Header />

      <section className="indiaboat-inner-page" id="yachtdetails_main">
        <div className="indiaboat-container">

          {/* ✅ Title */}
          <div className="indiaboat-hero-heading">
            <h1 className="indiaboat-main-title">
              {boatdetails?.boatname}
            </h1>
            <p className="indiaboat-subtitle">
              {boatdetails?.typeofyacht} - {boatdetails?.locationname}
            </p>
          </div>

          {/* ✅ Gallery + Booking */}
          <div className="indiaboat-gallery-wrapper">

            {/* LEFT : IMAGE SLIDER */}
            <div className="indiaboat-slider-alpha">

              <div className="vlt-media-container">
      {/* Tab Navigation */}
      <div className="vlt-media-tabs">
        <button 
          className={`vlt-tab-btn ${yachtMediaTab === 'photos' ? 'active' : ''}`}
          onClick={() => setYachtMediaTab('photos')}
        >
          <Camera size={16} />
          PHOTOS
        </button>
        <button 
          className={`vlt-tab-btn ${yachtMediaTab === 'video' ? 'active' : ''}`}
          onClick={() => setYachtMediaTab('video')}
        >
          <Play size={16} />
          VIDEO
        </button>
        <button 
          className={`vlt-tab-btn ${yachtMediaTab === 'map' ? 'active' : ''}`}
          onClick={() => setYachtMediaTab('map')}
        >
          <MapPin size={16} />
          MAP
        </button>
      </div>

      {/* Content Area */}
      <div className="vlt-media-viewport">
        {yachtMediaTab === 'photos' && (
          <div className="vlt-slider-container">
            <div 
              className="vlt-slider-track" 
              style={{ transform: `translateX(-${yachtGalleryIndex * 100}%)` }}
            >
              {yachtPhotoLibrary.map((url, idx) => (
                <div key={idx} className="vlt-slide">
                  <img src={url} alt={`Yacht view ${idx + 1}`} />
                </div>
              ))}
            </div>
            
            {/* Slider Controls */}
            <button className="vlt-slider-nav prev" onClick={handlePrevYachtSlide}>
              <ChevronLeft size={24} />
            </button>
            <button className="vlt-slider-nav next" onClick={handleNextYachtSlide}>
              <ChevronRight size={24} />
            </button>

            {/* Pagination Dots */}
            <div className="vlt-slider-dots">
              {yachtPhotoLibrary.map((_, idx) => (
                <span 
                  key={idx} 
                  className={`vlt-dot ${yachtGalleryIndex === idx ? 'active' : ''}`}
                  onClick={() => setYachtGalleryIndex(idx)}
                />
              ))}
            </div>
          </div>
        )}

        {yachtMediaTab === 'video' && (
          <div className="vlt-video-wrapper">
            <iframe 
              width="100%" 
              height="100%" 
              src="https://www.youtube.com/embed/XhtzBigoL34" 
              title="Yacht Experience Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            ></iframe>
          </div>
        )}

        {yachtMediaTab === 'map' && (
          <div className="vlt-map-wrapper">
            <iframe title={boatdetails?.locationname}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.2057398188044!2d72.83204917604586!3d18.92198915680155!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1c06aba07bb%3A0x691efed3f81e7d8!2sGateway%20Of%20India%20Mumbai!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" 
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
            <div className="vlt-map-float-card">
               <strong>Pickup Point</strong>
               <p>{boatdetails?.locationname}</p>
            </div>
          </div>
        )}
      </div>
      </div>
              <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                loop={true}
                slidesPerView={1}
              >
                <SwiperSlide>
                  <img src={imageUrl} alt="" className="indiaboat-slide-alpha" />
                </SwiperSlide>

                <SwiperSlide>
                  <img src={imageUrl} alt="" className="indiaboat-slide-alpha" />
                </SwiperSlide>
              </Swiper>
             
            </div>

            {/* RIGHT : BOOKING BOX */}
            <div className="yacht-booking-card-alpha">
              <div className="yacht_det_title">
                <h3 className="yacht-booking-title-alpha">
                {boatdetails?.typeofyacht}
              </h3>
 <label className="vlt-ds-main-label">Select Multipal Time Slot</label>
              </div>
               

              <div className="yacht-booking-time-alpha">
     

      <div className="time-slot-wrapper">
        {timeSlots.map((slot, index) => {
          const isSelected = selectedSlots.some(s => s.time === slot.time);
          const hasDiscount = slot.discount > 0;
          const finalPrice = hasDiscount
            ? slot.price - (slot.price * slot.discount) / 100
            : slot.price;

          return (
            <div
              key={index}
              className={`time-slot-box ${isSelected ? "selected" : ""} ${hasDiscount ? "vlt-ds-has-promo" : ""}`}
              onClick={() => handleSlotClick(slot)}
            >
              {/* {hasDiscount && (
                <div className="vlt-ds-promo-pill">
                  <Tag size={10} />
                  {slot.discount}% OFF
                </div>
              )} */}
              
              <div className="vlt-ds-slot-info">
                <p className="time">{slot.time}</p>
                <div className="vlt-ds-price-row">
                  <p className="price">₹{finalPrice.toLocaleString('en-IN')}</p>
                  {hasDiscount && (
                    <span className="vlt-ds-strike">₹{slot.price.toLocaleString('en-IN')}</span>
                  )}
                </div>
              </div>

              {isSelected && <CheckCircle2 size={16} className="vlt-ds-indicator" />}
            </div>
          );
        })}
      </div>

      <div className="date_capacity">
        <div className="yb-time-item-alpha">
        <label className="vlt-ds-main-label">Date</label>
        <div className="vlt-ds-input-container">
          <input
  type="date"
  className="vlt-ds-date-field"
  value={selectedDate}
  min={new Date().toISOString().split("T")[0]}  // ✅ IMPORTANT
  onChange={(e) => {
  setSelectedDate(e.target.value);
}}
/>

        </div>

       
      </div>
       <p className="yacht-booking-price-alpha">
                  Capacity: {boatdetails?.boatcapacity}
                </p>
      </div>
      </div>

              <div className="yacht-booking-footer-alpha">
                <p className="yacht-booking-location-alpha">
                  {boatdetails?.placename}
                </p>

                
              </div>

              <button
                className="th-btn style3 th-icon" id="book_now"
                onClick={handleAddToCart}
              >
                Book Now
              </button>


            <Sidebar/>
            </div>

          </div>

          {/* ✅ Tabs */}
          <div className="indiaboat-details-wrap">

            <div className="indiaboat-details-tabs">
              <button
                className={`indiaboat-tab-btn ${
                  activeTab === "description" ? "active" : ""
                }`}
                onClick={() => setActiveTab("description")}
              >
                Description
              </button>

              <button
                className={`indiaboat-tab-btn ${
                  activeTab === "specifications" ? "active" : ""
                }`}
                onClick={() => setActiveTab("specifications")}
              >
                Specifications
              </button>

              <button
                className={`indiaboat-tab-btn ${
                  activeTab === "amenities" ? "active" : ""
                }`}
                onClick={() => setActiveTab("amenities")}
              >
                Amenities
              </button>
            </div>

            {/* ✅ Description */}
            {activeTab === "description" && (
              <div className="indiaboat-tab-content">
                <div className="yacht-spec-container">

                  <div className="yacht-spec-row">
                    <div className="yacht-spec-key">YACHT NAME:</div>
                    <div className="yacht-spec-value">
                      {boatdetails?.boatname}
                    </div>
                  </div>

                  <div className="yacht-spec-row">
                    <div className="yacht-spec-key">YACHT LENGTH:</div>
                    <div className="yacht-spec-value">
                      {boatdetails?.dimention}
                    </div>
                  </div>

                  <div className="yacht-spec-row">
                    <div className="yacht-spec-key">TYPE OF HULL:</div>
                    <div className="yacht-spec-value">
                      {boatdetails?.typeofhull}
                    </div>
                  </div>

                </div>
              </div>
            )}

            {/* ✅ Specifications */}
            {activeTab === "specifications" && (
              <div className="indiaboat-tab-content">
                <div
                  dangerouslySetInnerHTML={{
                    __html: boatdetails?.features || "",
                  }}
                />
              </div>
            )}

            {/* ✅ Amenities */}
            {activeTab === "amenities" && (
              <div className="indiaboat-tab-content">
                <div
                  dangerouslySetInnerHTML={{
                    __html: boatdetails?.instructions || "",
                  }}
                />
              </div>
            )}

            <button
              className="yacht-booking-btn-alpha"
              onClick={handleAddToCart}
            >
              Book Now
            </button>

          </div>

          {/* CTA */}
          <div className="indiaboat-cta">
            <h2 className="indiaboat-cta-title">
              Ready to Plan Your Voyage?
            </h2>

            <p className="indiaboat-cta-text">
              Contact us today for your dream charter.
            </p>

            <a href="/contact" className="indiaboat-cta-btn">
              Enquire & Book
            </a>
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
}
